import { Z } from "./query";
import { SignDesigner } from "./signDesigner";
import { QuoteBuilder } from './quoteBuilder';
import { AppModal } from "./appModals";
import { AddressFieldEditor } from "./addressFieldEditor";
import { ContextMenu } from "./contextMenuControl";
import { Flourishes } from "./flourishes";
import { DataVisibleWhen } from "./visibleWhen";
import bootstrap = require("bootstrap");
import { AuthorisedDDSBSite } from "./ddsbAuthed";

export class DDSB {
    static log(...lines: any[]) {
        //let container = Z.first('.debug-log');
        lines.forEach(line => {
            if (console) console.log(line);
            Z.forFirst('.debug-log', container => {
                let div = document.createElement('div');
                div.innerText = line;
                container.appendChild(div);
            });
        });
    }

    static instance: DDSB;

    static instanceCount: number = 0;
    constructor() {
        if (DDSB.instance) {
            throw new Error('DDSB app is already initialised');
        }

        DDSB.instance = this;
        window['Web'] = this;
        window['DDSB'] = this;
        window['ddsb'] = this;

        document.addEventListener('update-gui', ev => this.updateGui());

        this.initGui();
        DDSB.instanceCount++;
        DDSB.log(`DDSB initialised | ${DDSB.instanceCount}`);

        this.quoteBuilder = QuoteBuilder.init(this);

        if (document.body.classList.contains('authed')) {
            if (document.body.dataset.uid) {
                this.authed = new AuthorisedDDSBSite();
            }
        } else {
            try {
                let params = new URLSearchParams(window.location.search);
                if (params.has('signin')) {
                    this.signIn();
                }
            } catch (err) { }
        }
    }
    authed: AuthorisedDDSBSite;

    quoteBuilder: QuoteBuilder;

    debugThemeTimer;
    debugTheme(interval: number = 5000) {
        clearTimeout(this.debugThemeTimer);
        Z.restyle();
        this.debugThemeTimer = setTimeout(() => this.debugTheme(interval), interval);
    }

    signDesigner: SignDesigner = null;

    signIn() {
        Z.showModal('/account/signin', modal => {
            let email = Z.firstFrom<HTMLInputElement>(modal, '#sign-in-email');
            let password = Z.firstFrom<HTMLInputElement>(modal, '#sign-in-pwd');

            let forgotPasswordButton = Z.firstFrom<HTMLButtonElement>(modal, '#forgot-my-password-button');
            forgotPasswordButton.disabled = true;

            ['input', 'change', 'keypress'].forEach(cb => email.addEventListener(cb, ev => {
                forgotPasswordButton.disabled = true;
                if (email.value && email.value.length) {
                    let tester = document.createElement('input');
                    tester.type = 'email';
                    tester.required = true;
                    tester.value = email.value;
                    if (typeof tester.checkValidity === 'function' ? tester.checkValidity() : /\S+@\S+\.\S+/.test(email.value)) {
                        forgotPasswordButton.disabled = false;
                    }
                }
            }));

            let passwordRow = Z.firstFrom(modal, '#password-row');
            let passwordResetRow = Z.firstFrom(modal, '#password-reset-code-row');

            let requestResetCode = Z.firstFrom<HTMLButtonElement>(modal, '#request-reset-code');

            let feedback = Z.firstFrom(modal, '#sign-in-feedback');

            let form = Z.firstFrom<HTMLFormElement>(modal, 'form');

            forgotPasswordButton.addEventListener('click', ev => {
                passwordRow.classList.remove('visible');
                passwordResetRow.classList.add('visible');
                form.action = `/account/resetpassword`;
            });

            requestResetCode.addEventListener('click', ev => {
                requestResetCode.disabled = true;
                setTimeout(() => requestResetCode.disabled = false, 5000);

                let fd = new FormData();
                fd.append('email', email.value);
                feedback.classList.remove('active');

                fetch(`/account/forgotpassword`, {
                    method: 'post',
                    body: fd,
                }).then(resp => {
                    if (resp.ok) {
                        resp.text().then(txt => {
                            console.log(txt);
                            feedback.innerText = txt;
                            feedback.classList.add('active');
                        });
                    }
                });
            });
        });
    }

    initGui() {
        this.signDesigner = SignDesigner.init(this);
        Z.bindLiveGui(ev => this.updateGui());

        Z.init('.sign-in-button', el => el.addEventListener('click', ev => this.signIn()));

        Z.init('.panel.panel-collapsible.panel-collapse-others', el => {
            let collapse = Z.firstFrom(el, '.collapse');
            //let panel = bootstrap.Collapse.getOrCreateInstance(collapse);
            collapse.addEventListener('show.bs.collapse', ev => {
                let others = Z.selectFrom(el.parentElement, '.panel.panel-collapsible .collapse');
                others.forEach(e => {
                    if (e == collapse) return;
                    let collapser = bootstrap.Collapse.getOrCreateInstance(e);
                    collapser?.hide();
                });
            });
        });

        Z.init<HTMLInputElement>('input[data-intercept-newline]', 'intercept-newline', el => {
            el.addEventListener('keydown', ev => {
                //console.log('keydown', ev);
                if (ev.key == 'Enter') {
                    let thenIntercept = el.dataset.interceptNewline;
                    console.log(`Intercept [${thenIntercept}]`);
                    Z.forEach(thenIntercept, next => {
                        console.log(`=> `, next);
                        if (next.matches('button, a')) {
                            next.click();
                        } else if (next.matches('input, textarea')) {
                            next.focus();
                            (<HTMLInputElement>next).select();
                        }
                    });
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                return true;
            });
        });

        if (location.hash && location.hash.length > 1) {
            if (Z.any('.accordion')) {
                let siv = false;

                Z.forFirst(`button[data-bs-target="${location.hash}"]`, el => {
                    console.log(`Scroll to: ${location.hash}`);
                    let accordionItem = Z.getParent(el, '.accordion-item');
                    console.log(`Accordion item`, accordionItem);
                    let superAccordionItem = Z.getParent(accordionItem.parentElement, '.accordion-item');
                    if (superAccordionItem) {
                        console.log(`Super accordion item`, superAccordionItem);
                        let superAccordionItemButton = Z.firstFrom(superAccordionItem, `button.accordion-button`);
                        if (superAccordionItemButton && superAccordionItemButton.getAttribute('aria-expanded') != 'true') {
                            superAccordionItemButton.click();
                            superAccordionItemButton.scrollIntoView();
                            siv = true;
                        }
                    }

                    el.click();
                    if (!siv) el.scrollIntoView();
                });
            }

            Z.forFirst(`button[data-bs-toggle="tab"]${location.hash}`, el => {
                el.scrollIntoView();
                el.click();
            });
        }

        Z.init(`.tabs-nav-supplemental`, 'supplemental-nav-tabs', el => {
            //console.log(`supplemental tab navs...`);
            let buttons = Z.selectFrom(el, 'button, a');
            //console.log(`buttons`, buttons);
            let tabContent = Z.getParent(el, '.tab-content');
            //console.log(`tabcontent`, tabContent);
            let tabContainer = tabContent?.parentElement;
            //console.log(`tabcontainer`, tabContainer);

            if (buttons.length > 1 && tabContent && tabContainer) {
                let prev = buttons[0];
                let next = buttons[1];

                let nav = (dir: -1 | 1) => {
                    let navs = Z.firstFrom(tabContainer, 'nav > [role="tablist"]');
                    //console.log(tabContainer, navs);
                    if (navs) {
                        let buttons = Z.selectFrom(navs, 'button.nav-link');
                        let index = buttons.findIndex(b => b.classList.contains('active'));
                        //console.log(`nav ${dir}`, navs, buttons, index);
                        index += dir;
                        if (index < 0) index = buttons.length - 1;
                        if (index >= buttons.length) index = 0;

                        if (index >= 0 && index < buttons.length) {
                            buttons[index].click();
                        }
                    }
                };

                prev.addEventListener('click', ev => nav(-1));
                next.addEventListener('click', ev => nav(1));
            }
        });
    }

    updateGui() {
        //console.log('update layout');

        AppModal.init();
        AddressFieldEditor.init();

        Flourishes.init();

        DataVisibleWhen.init();

        Z.init(`.leftright > .with-img.autoscale, .leftright > .with-img.autoscaleonce`, 'leftright-image-sizer', el => {

            let isLeft = el.classList.contains('left');
            let other = Z.firstFrom(el.parentElement, isLeft ? '.right' : '.left');
            let img = Z.firstFrom<HTMLImageElement>(el, 'img');

            if (other && img) {
                let resizer = () => {
                    if (!el.classList.contains('autoscaleonce') && !el.classList.contains('autoscale')) return;

                    if (!img.naturalWidth) return;

                    let bounds = other.getBoundingClientRect();
                    let max = Math.max(img.naturalWidth, img.naturalHeight);
                    let min = Math.min(bounds.width, bounds.height);
                    let aspect = img.naturalWidth / img.naturalHeight;

                    el.style.height = `${min / aspect}px`;

                    if (el.classList.contains('autoscaleonce')) {
                        el.classList.remove('autoscaleonce');
                    }
                };

                if (globalThis['ResizeObserver']) {
                    let rsobserver = new globalThis['ResizeObserver'](resizer);
                    rsobserver.observe(other);
                }

                resizer();
            }
        });

        Z.init<HTMLInputElement>('input[pattern]', 'input-pattern-matching', el => {
            let revert = el.value;
            el.addEventListener('keydown', ev => revert = el.value);
            /* el.addEventListener('keyup', ev => revert = el.value);
            el.addEventListener('keypress', ev => revert = el.value);
            el.addEventListener('change', ev => revert = el.value); */
            el.addEventListener('input', ev => {
                //console.log(`Does this input [${(<any>ev).data}] match pattern [${el.pattern}]? ${el.checkValidity()}`);
                if (el.checkValidity()) {
                    revert = el.value;
                } else {
                    el.value = revert;
                    ev.preventDefault();
                    ev.stopPropagation();
                    return false;
                }
            });
        });

        Z.init<HTMLInputElement>(`[data-search-abn-to-company-name]`, 'data-search-abn-to-company-name', el => {
            /* el.addEventListener('input', ev => {
                if (el.checkValidity() && el.value.split(' ').join('').length == 11) {
                    Z.changed(el);
                }
            }); */
            el.addEventListener('change', ev => {
                ev.preventDefault();
                ev.stopPropagation();

                el.classList.remove('is-invalid');
                el.classList.remove('is-valid');
                let applyTo = el.dataset.searchAbnToCompanyName;
                let elId = el.id;

                if (el.checkValidity() && el.value.split(' ').join('').length == 11) {
                    fetch(`/abn/lookup/company/${el.value}`)
                        .then(resp => {
                            if (resp.ok) {
                                el = Z.first(`#${elId}`);

                                resp.json().then(json => {
                                    console.log(json);
                                    if (json.businessEntity) {
                                        if (json.businessEntity.mainName && json.businessEntity.mainName.length) {
                                            let businessName = json.businessEntity.mainName[0].organisationName;
                                            console.log(`${businessName} => ${applyTo}`);
                                            Z.forEach<HTMLInputElement>(applyTo, el => {
                                                if (!(el.value + '').trim().length) {
                                                    el.value = businessName;
                                                }
                                            });
                                        }
                                        console.log(json.businessEntity);
                                        el.classList.add('is-valid');
                                    } else {
                                        console.log(`ABN company not found`);
                                        el.classList.add('is-invalid');
                                    }
                                    //console.log(json);
                                });
                            } else {
                                console.log(resp);
                                resp.text().then(txt => console.log(txt));
                            }
                        });
                } else {
                    el = Z.first(`#${elId}`);
                    el.classList.add('is-invalid');
                }
            });
        });

        Z.init('#sidebar-toggle-button', '#sidebar-toggle-button', btn => {
            btn.addEventListener('click', ev => {
                btn.classList.toggle('active');
                if (btn.classList.contains('active')) {
                    Z.forFirst('#ddsb-sidebar', sb => sb.classList.add('active'));
                } else {
                    Z.forFirst('#ddsb-sidebar', sb => sb.classList.remove('active'));
                }
            });
        });

        /*Z.init(document.body, 'swipe-handler', el => {
            let originX = 0, originY = 0;
            el.addEventListener('touchstart', ev => {
                originX = ev.touches[0].screenX;
                originY = ev.touches[0].screenY;

                let sidebar = Z.first('#ddsb-sidebar.active');
                if (sidebar) {
                    if (Z.outOfBounds(sidebar, ev.touches[0].clientX, ev.touches[0].clientY)) {
                        sidebar.classList.remove('active');
                        ev.preventDefault();
                        ev.stopPropagation();
                        return false;
                    }
                }
            }, { passive: false });
            el.addEventListener('touchmove', ev => {
                let tx = ev.changedTouches[0].screenX;
                let ty = ev.changedTouches[0].screenY;

                let deltaX = tx - originX;
                let deltaY = ty - originY;

                let delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                if (Math.abs(deltaX) > 100) {
                    if (deltaX > 0) {
                        Z.forFirst('#ddsb-sidebar:not(.active)', el => {
                            el.classList.add('active');
                            ev.preventDefault();
                            ev.stopPropagation();
                        });
                    }
                    else if (deltaX < 0) {
                        Z.forFirst('#ddsb-sidebar.active', el => {
                            el.classList.remove('active');
                            ev.preventDefault();
                            ev.stopPropagation();
                        });
                    }
                }
            }, {
                passive: false,
            });

            el.addEventListener('touchend', ev => {
            });
        });*/

        Z.init('.asymmetric-photo-grid > button', 'asymmetric-photo-grid-button', el => {
            //el.addEventListener('click', ev => el.classList.toggle('active'));
            el.addEventListener('click', ev => {
                let bgSource = el.style.backgroundImage;
                let div = document.createElement('div');
                div.classList.add('fs-gallery-img');
                div.style.backgroundImage = bgSource;
                div.dataset.index = Z.indexOf(el).toString();

                let prev = document.createElement('button');
                prev.type = 'button';
                prev.className = 'gallery-nav prev';
                prev.addEventListener('click', ev => {
                    this.switchAsymmetricPhoto(el, -1);
                    ev.preventDefault();
                    ev.stopPropagation();
                });

                let next = document.createElement('button');
                next.type = 'button';
                next.className = 'gallery-nav next';
                next.addEventListener('click', ev => {
                    this.switchAsymmetricPhoto(el, 1);
                    ev.preventDefault();
                    ev.stopPropagation();
                });

                div.appendChild(prev);
                div.appendChild(next);

                Z.forFirst('.async-modals', b => b.appendChild(div));
                setTimeout(() => {
                    div.classList.add('active');
                    div.addEventListener('click', ev => {
                        div.classList.remove('active');
                        setTimeout(() => {
                            div.remove();
                        }, 1000);
                    });
                }, 1);
            });
        });

        Z.init('html', 'scroll-bg-parallax', el => {
            let html = Z.first('html');
            let scrollTopDiv = html.scrollTop;
            let scroller = () => {

                if (html.scrollTop != scrollTopDiv) {
                    scrollTopDiv = html.scrollTop;
                    Z.forEach('.background-image.top', bg => {
                        bg.style.backgroundPositionY = `${scrollTopDiv * 0.5}px`;
                    });
                }

                window.requestAnimationFrame(() => scroller());
            };
            scroller();
            /* console.log(`html el`, el);
            document.addEventListener('scroll', ev => {
                let html = Z.first('html');
                Z.forEach('.background-image.top', bg => {
                    bg.style.backgroundPositionY = `${html.scrollTop * 0.5}px`;
                });
                //console.log(`background scroll, ${html.scrollTop}`);
            }, {
                passive: true,
            }); */
        });

        /* Z.init('[data-increment][data-increment-by]', 'inc-spin-buttons', el => {
            el.addEventListener('click', ev => {
                let incrementor = parseInt(el.dataset.incrementBy);
                let target = el.dataset.increment;
                //console.log(`increment ${target} by ${incrementor}`);
                if (Z.any(target)) {
                    Z.forEach<HTMLInputElement>(`input${target}`, input => {
                        let value = parseInt(input.value);
                        let min = parseInt(input.min || '0');
                        let max = parseInt(input.max || '100000000');
                        if (!isNaN(value)) {
                            value += incrementor;
                            if (!isNaN(min)) value = Math.max(min, value);
                            if (!isNaN(max)) value = Math.min(max, value);
                            input.value = `${value}`;
                            Z.trigger(target, 'change');
                            //console.log(`change -> ${value}`, target);
                        }
                    });
                }
            });
        }); */

        Z.init('[data-download], [data-open]', 'open href buttons', el => {
            el.addEventListener('click', ev => {
                let href = el.dataset.download ?? el.dataset.open;
                if (href) window.open(href);
            });
        });
        Z.init('[data-go], [data-goto]', 'href buttons', el => {
            el.addEventListener('click', ev => {
                Z.spinUp(el);
                location.href = el.dataset.go ?? el.dataset.goto;
            });
        });
        Z.init('[data-get]', 'href get buttons', el => {
            el.addEventListener('click', ev => {
                Z.get(el, el.dataset.get);
            });
        });
        Z.init('[data-reset]', 'reset-form-trigger', btn => {
            btn.addEventListener('click', ev => {
                let form: HTMLFormElement;
                if (btn.dataset.submit === 'this') {
                    form = Z.getParent<HTMLFormElement>(btn, 'form');
                } else {
                    form = Z.one<HTMLFormElement>(btn.dataset.submit);
                }

                if (!form) throw new DOMException(`Form with selector '${btn.dataset.submit}' not found`);

                form.reset();
            });
        });

        Z.init('[data-submit]', 'submit-form-trigger', btn => {
            btn.addEventListener('click', ev => {
                let form: HTMLFormElement;
                if (btn.dataset.submit === 'this') {
                    form = Z.getParent<HTMLFormElement>(btn, 'form');
                } else {
                    form = Z.one<HTMLFormElement>(btn.dataset.submit);
                }

                if (!form) throw new DOMException(`Form with selector '${btn.dataset.submit}' not found`);

                Z.spinUp(btn);
                Z.submitFormAsync(btn, form);
            });
        });
    }

    switchAsymmetricPhoto(btn: HTMLElement, dir: number) {
        let activePhoto = Z.first('.fs-gallery-img');
        let gallery = Z.getParent(btn, '.asymmetric-photo-grid');
        //console.log(`src button:`, btn);
        //console.log(`active photo:`, activePhoto);
        //console.log(`gallery:`, gallery);

        let index = parseInt(activePhoto.dataset.index);
        let others = Z.selectFrom(gallery, 'button');

        let nextIndex = index + dir;
        if (nextIndex < 0) nextIndex += others.length;
        if (nextIndex >= others.length) nextIndex -= others.length;

        //console.log(`[${index}] -> [${nextIndex}]`);

        let nextBtn = others[nextIndex];
        activePhoto.style.backgroundImage = nextBtn.style.backgroundImage;
        activePhoto.dataset.index = nextIndex.toString();
    }

    logImage(src: string) {
        let image = new Image();
        image.onload = () => {
            let style = [
                'fontSize: 1px;',
                `padding: ${image.naturalHeight}px ${image.naturalWidth}px;`,
                `background: url(${src}) no-repeat;`,
                `background-size: contain;`,
                `image-rendering: crisp-edges;`,
                `image-rendering: pixelated;`,
            ].join(' ');
            console.log('%c ', style, `[${image.naturalWidth} x ${image.naturalHeight}]`);
        };
        image.src = src;
    }
}

//document?.querySelector('div.debug-log')?.innerHTML += '<h5>READY</h5>';

if (document.readyState === 'complete') {
    new DDSB();
}
else {
    document.addEventListener('readystatechange', ev => {
        if (document.readyState == 'interactive') {
        }

        if (document.readyState === 'complete') {
            new DDSB();
        }
    });
}